export const TEMPLATE_TOKEN = {
  blotName: 'templateToken',
  className: 'ql-template-token',
  codePattern: /^[A-Za-z0-9_.]+$/,
  /**
   * Inside the braces the backend accepts ASCII whitespace and U+00A0. A line break is left out:
   * a placeholder typed across two paragraphs stays text, so its conversion cannot join them.
   */
  placeholderPattern: /\{\{[ \t\v\f\r\u00A0]*(?<code>[A-Za-z0-9_.]+)[ \t\v\f\r\u00A0]*\}\}/g,
  guardPattern: /\uFEFF/g,
  toPlaceholder: (code: string) => `{{ ${code} }}`,
} as const;
